module.exports = __webpack_public_path__ + "static/media/google-plus-g.ad7d09ea.svg";